export default {"src":"/_next/static/media/suggestions-active-icon.41e31065.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};